import { render, staticRenderFns } from "./OverflowContainer.vue?vue&type=template&id=50932441"
import script from "./OverflowContainer.vue?vue&type=script&lang=js"
export * from "./OverflowContainer.vue?vue&type=script&lang=js"
import style0 from "./OverflowContainer.vue?vue&type=style&index=0&id=50932441&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/skade-pwa/components/ui/atom/Icon.vue').default})
